// Get Shopify Product Types
export const GET_SHOPIFY_PRODUCT_TYPES_REQUEST = 'GET_SHOPIFY_PRODUCT_TYPES_REQUEST';
export const GET_SHOPIFY_PRODUCT_TYPES_DONE = 'GET_SHOPIFY_PRODUCT_TYPES_DONE';
export const GET_SHOPIFY_PRODUCT_TYPES_FAILED = 'GET_SHOPIFY_PRODUCT_TYPES_FAILED';
export const GET_SHOPIFY_PRODUCT_TYPES_RESET = 'GET_SHOPIFY_PRODUCT_TYPES_RESET';

// Operations
export const SHOPIFY_PRODUCT_TYPES_SET_PAGE = 'SHOPIFY_PRODUCT_TYPES_SET_PAGE';
